/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { OrdersFilteringRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { PagedOrderLight } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Display the list of orders for the authenticated User
         * @summary Get the orders info for a User
         * @param {string} storeId The store identifier.
         * @param {OrdersFilteringRequest} [ordersFilteringRequest] The request object for order request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrders: async (storeId: string, ordersFilteringRequest?: OrdersFilteringRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCustomerOrders', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/order/orderTrackingList`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordersFilteringRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Display the details of order for the authenticated User and order ID
         * @summary Get the order detail using the order ID
         * @param {string} storeId The store identifier.
         * @param {string} orderId The order identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrdersByID: async (storeId: string, orderId: string,options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCustomerOrdersByID', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCustomerOrdersByID', 'orderId', orderId)
            const localVarPath = `/store/{storeId}/order/{orderId}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"orderId"}}`, String(orderId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (options?.shopId !== undefined) {
                localVarQueryParameter['shopId'] = options?.shopId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * Display the list of orders for the authenticated User
         * @summary Get the orders info for a User
         * @param {string} storeId The store identifier.
         * @param {OrdersFilteringRequest} [ordersFilteringRequest] The request object for order request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerOrders(storeId: string, ordersFilteringRequest?: OrdersFilteringRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrderLight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerOrders(storeId, ordersFilteringRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Display the details of order for the authenticated User and order ID
         * @summary Get the order detail using the order ID
         * @param {string} storeId The store identifier.
         * @param {string} orderId The order identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerOrdersByID(storeId: string, orderId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerOrdersByID(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * Display the list of orders for the authenticated User
         * @summary Get the orders info for a User
         * @param {string} storeId The store identifier.
         * @param {OrdersFilteringRequest} [ordersFilteringRequest] The request object for order request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrders(storeId: string, ordersFilteringRequest?: OrdersFilteringRequest, options?: any): AxiosPromise<PagedOrderLight> {
            return localVarFp.getCustomerOrders(storeId, ordersFilteringRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Display the details of order for the authenticated User and order ID
         * @summary Get the order detail using the order ID
         * @param {string} storeId The store identifier.
         * @param {string} orderId The order identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrdersByID(storeId: string, orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getCustomerOrdersByID(storeId, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * Display the list of orders for the authenticated User
     * @summary Get the orders info for a User
     * @param {string} storeId The store identifier.
     * @param {OrdersFilteringRequest} [ordersFilteringRequest] The request object for order request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getCustomerOrders(storeId: string, ordersFilteringRequest?: OrdersFilteringRequest, options?: any) {
        return OrdersApiFp(this.configuration).getCustomerOrders(storeId, ordersFilteringRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Display the details of order for the authenticated User and order ID
     * @summary Get the order detail using the order ID
     * @param {string} storeId The store identifier.
     * @param {string} orderId The order identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getCustomerOrdersByID(storeId: string, orderId: string, options?: any) {
        return OrdersApiFp(this.configuration).getCustomerOrdersByID(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}
